import React, { Component } from 'react'


import './index.css'

export class Home extends Component {
  render() {
    return (
      <>
      <div className='home-route'>
        <h1 className='home-route-content'>
            Web development is an empowering journey where creativity meets technology.
            It's accessible to all, fosters collaboration, and constantly evolves. Embrace
            the challenges, learn, collaborate, and make a meaningful impact on the digital world.
            Join the inspiring web development community!
        </h1>  
      </div>      
      </>
    )
  }
}

export default Home